import { gql } from '@apollo/client/core';

/** Every field `Discount.fromGql` maps — `isFixedAmount` / `isPercentage` deliberately excluded. */
export const DISCOUNT_FIELDS = gql`
  fragment DiscountFields on Discount {
    id
    eventId
    label
    code
    amount
    numericAmount
    kind
    type
    limit
    timesUsed
    usable
    expiration
    joinitMembershipType
    ticketBlueprintIds
    createdAt
    updatedAt
  }
`;
